<template>
    <v-container fluid>

        <v-row class="mt-6 mr-6 ml-6">
            <v-col cols="12" sm="12">
                <h1 style="margin-left: 20px;">散佈圖</h1>
            </v-col>
            <v-col cols="12" sm="6">
                <v-row>
                    <h3 class="mt-3 ml-12">X軸資料來源:</h3>
                    <v-select v-model="choice_x" @change="select_question('x')" :items="single_choice_sonX" label="選擇題目" item-text="title" item-value="id" single-line class="input_300 ml-3" outlined></v-select>
                </v-row>
                <v-row>
                    <h3 class="mt-3 ml-12">Y軸資料來源:</h3>
                    <v-select v-model="choice_y" @change="select_question('y')" :items="single_choice_sonY" label="選擇題目"  item-text="title" item-value="id" single-line class="input_300 ml-3" outlined></v-select>
                </v-row>
                <v-row>
                    <v-btn class="ml-12" color="success" @click="scatter_submit">送出</v-btn>
                </v-row>
            </v-col>
            <v-col cols="12" sm="6">
                <ve-scatter :data="scatter_chartData" :extend="scatter_chartExtend" :settings="scatter_chartSettings" :legend-visible="false"></ve-scatter>
            </v-col>
        </v-row>

        <v-row class="mt-6 mr-6 ml-6">
            <v-col cols="12" sm="12">
                <h1 style="margin-left: 20px;">四象限圖</h1>
            </v-col>
            <v-col cols="12" sm="6">
                <v-row>
                    <h3 class="mt-3 ml-12">題目:</h3>
                    <v-select v-model="matrix_id" :items="matrix_question"  @change="select_four('o')" item-text="title" item-value="id" label="選擇題目" class="input_400 ml-3" outlined></v-select>
                </v-row>
                <v-row v-if="matrix_id !==-1">
                    <h3 class="mt-3 ml-12">X軸資料來源:</h3>
                    <v-select v-model="four_axis_x" :items="matrix_son_questionX" @change="select_four('x')" item-text="title" item-value="id" label="選擇子問題" class="input_300 ml-3" outlined></v-select>
                </v-row>
                <v-row v-if="matrix_id !==-1">
                    <h3 class="mt-3 ml-12">Y軸資料來源:</h3>
                    <v-select v-model="four_axis_y" :items="matrix_son_questionY" @change="select_four('y')" item-text="title" item-value="id" label="選擇子問題" class="input_300 ml-3" outlined></v-select>
                </v-row>
                <v-row v-if="four_axis_x!='' && four_axis_y!=''">
                    <v-btn class="ml-12" color="success" @click="four_submit">送出</v-btn>
                </v-row>
            </v-col>
            <v-col cols="12" sm="6" v-if="Object.keys(four_axis_chartData).indexOf('rows')!==-1">
                <ve-scatter :mark-line="four_axis_markLine" :data="four_axis_chartData" :extend="four_axis_chartExtend" :settings="four_axis_chartSettings"></ve-scatter>
                <!-- <ve-scatter  :data="four_axis_chartData" :settings="four_axis_chartSettings"></ve-scatter> -->
            </v-col>
        </v-row>

    </v-container>
</template> 

<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL

export default {
    
    data(){
        // four_axis
        this.four_axis_markLine = {}
        this.four_axis_chartSettings = {}
        this.four_axis_chartExtend = {}

        // scatter
        this.scatter_chartSettings = {}
        this.scatter_chartExtend = {}

        return{
            account_survey_id_list: [],

            // four_axis
            four_axis_x: '',
            four_axis_y: '',
            four_axis_chartData: {},

            matrix_question: [],
            matrix_id: -1,
            matrix_son_question: {},
            matrix_son_questionX: [],
            matrix_son_questionY: [],

            // scatter
            single_choice: [],
            choice_x: -1,
            choice_y: -1,
            single_choice_sonX: [],
            single_choice_sonY: [],
            choice_dict: {},

            scatter_x: '',
            scatter_y: '',
            scatter_chartData:{},
        }
    },
    created(){
        this.account_survey_id_list = JSON.parse(localStorage.getItem('SON_SURVEY_SELECTED'))
        if(this.account_survey_id_list==null || this.account_survey_id_list==undefined || this.account_survey_id_list==[]){
            bus.$emit('alert', {msg: "操作異常", title: "提示",　check: "我知道了"})
            this.$router.push('/cross_analysis?m=3')
        }
        this.get_question_list()
    },
    methods: {
        // scatter
        select_question(axis){
            if(axis == 'o'){
                this.single_choice_sonX = this.single_choice
                this.single_choice_sonY = this.single_choice
                return
            }
            if(axis == 'x'){
                this.single_choice_sonY = []
                for(let k of this.single_choice)
                    if(k.id != this.choice_x)
                        this.single_choice_sonY.push(k)
            }
            else{
                this.single_choice_sonX = []
                for(let k of this.single_choice)
                    if(k.id != this.choice_y)
                        this.single_choice_sonX.push(k)
            }
        },
        scatter_submit(){
            let post_data = {x: this.choice_x,
                             y: this.choice_y,
                             account_survey_id_list: this.account_survey_id_list}

            axios.post(host_url+'scatter_update/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.scatter_chartData = tmp.chart_data
                    this.scatter_chartSettings = tmp.chart_setting
                    this.scatter_chartExtend = tmp.chart_extend
                    this.choice_dict = tmp.choice_dict

                    // 更新y軸 
                    this.scatter_chartExtend['yAxis']['axisLabel'] = {
                        formatter: (d)=>{ 
                            if(d-1<0)
                                return ''
                            else
                                return this.choice_dict[this.choice_y][d-1].title
                        }
                    }
                    // 更新x軸
                    this.scatter_chartExtend['xAxis']['axisLabel'] = {
                        formatter: (d)=>{ 
                            if(d-1<0)
                                return ''
                            else
                                return this.choice_dict[this.choice_x][d-1].title
                        }
                    }

                    // 更新 tooltip
                    this.scatter_chartExtend['tooltip'] = {
                        formatter: (d)=>{
                            return String(d.data.value[2])+'人'
                        }
                    }
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },


        // four_axis
        four_submit(){
            let post_data = {
                account_survey_id_list: this.account_survey_id_list,
                question_group_id: this.matrix_id,
                question_x: this.four_axis_x,
                question_y: this.four_axis_y,
            }
            axios.post(host_url+'four_axis/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.four_axis_chartData = tmp.chart_data
                    this.four_axis_chartSettings = tmp.chart_setting
                    this.four_axis_chartExtend = tmp.chart_extend
                    this.four_axis_markLine = tmp.mark_line

                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            });
        },
        select_four(axis){
            if(axis == 'o'){
                this.matrix_son_questionX = this.matrix_son_question[this.matrix_id]
                this.matrix_son_questionY = this.matrix_son_question[this.matrix_id]
                return
            }
            if(axis == 'x'){
                this.matrix_son_questionY = []
                for(let k of this.matrix_son_question[this.matrix_id])
                    if(k.id != this.four_axis_x)
                        this.matrix_son_questionY.push(k)
            }
            else{
                this.matrix_son_questionX = []
                for(let k of this.matrix_son_question[this.matrix_id])
                    if(k.id != this.four_axis_y)
                        this.matrix_son_questionX.push(k)
            }
        },        
        get_question_list(){
            let post_data = {account_survey_id_list: this.account_survey_id_list}

            axios.post(host_url+'get_question_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    console.log(tmp)
                    for(let q of tmp.question_list){
                        // 單選題匯入
                        if(q.type==1){
                            this.single_choice.push({id: q.id, title: q.question.title})
                        }
                        if(q.type==3){
                            this.matrix_question.push({id: q.id, title: q.question.title})
                            let son_question = []
                            for(let k of q.question.description_list){
                                son_question.push({id: k.id, title: k.title})
                            }
                            this.matrix_son_question[q['id']] = son_question
                        }
                        
                    }
                    this.select_question('o')
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },
    },
}
</script>

<style lang="scss" scoped>

::v-deep .input_200{
    max-width: 200px;
}

::v-deep .input_300{
    max-width: 300px;
}

::v-deep .input_360{
    max-width: 360px;
}

::v-deep .input_400{
    max-width: 400px;
}

::v-deep .input_480{
    max-width: 480px;
}

</style>

